/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  useBreakpointValue
} from '@chakra-ui/react'
import FilterList from './components/FilterList'
import { useDefaultFilterInput } from './useDefaultFilterInput'
import Buttons from './components/Buttons'
import InputText from './components/InputText'
import {
  DEFAULT_APPLY_FILTER_LABEL,
  DEFAULT_INPUT_PLACEHOLDER,
  DEFAULT_NO_FILTER_ERROR_MESSAGE
} from '@/configs/strings/filters.strings'

const DefaultFilterInput = ({
  errorMessage = DEFAULT_NO_FILTER_ERROR_MESSAGE,
  filterByValue,
  filterOptions = [],
  filterTextValue = '',
  labeInputText = DEFAULT_INPUT_PLACEHOLDER,
  labelFilter = DEFAULT_APPLY_FILTER_LABEL,
  onFilter,
  onReset,
  searchResultsKeyData,
  searchResultsKeyLabel,
  searchResultsKeyValue
}) => {
  const {
    applyFilter,
    availableFilters,
    errorMessage: hookErrorMessage,
    filterContainerClass,
    filterId,
    filterSelected,
    filterType,
    filterValue,
    handleAutocompleteChange,
    handleInputChange,
    handleKeyPress,
    hasError,
    resetFilter,
    selectFilter
  } = useDefaultFilterInput({
    filterOptions,
    initialFilterId: filterByValue,
    initialFilterValue: filterTextValue,
    onFilter,
    onReset
  })
  const displayErrorMessage = hookErrorMessage || errorMessage
  const flexDirection = {
    base: 'column',
    md: 'row'
  }
  const gap = { base: '3', md: '0' }
  const textClass = useBreakpointValue({
    base: '!text-sm',
    md: '!text-xs'
  })
  return (
    <FormControl
     isInvalid={hasError}
    >
      <Flex
        direction={flexDirection}
        gap={gap}
      >
        <Box>
          <Flex
            className={filterContainerClass}
            direction={flexDirection}
            gap={gap}
          >
            <InputText
              filterId={filterId}
              filterOptions={filterOptions}
              filterType={filterType}
              filterValue={filterValue}
              handleAutocompleteChange={handleAutocompleteChange}
              handleInputChange={handleInputChange}
              handleKeyPress={handleKeyPress}
              labeInputText={labeInputText}
              searchResultsKeyData={searchResultsKeyData}
              searchResultsKeyLabel={searchResultsKeyLabel}
              searchResultsKeyValue={searchResultsKeyValue}
            />
            <FilterList
              filters={availableFilters}
              setCurrentId={selectFilter}
              filterByValue={filterSelected}
            />
          </Flex>
          { hasError &&
            <FormErrorMessage
              className={textClass}
            >
              { displayErrorMessage }
            </FormErrorMessage>
          }
        </Box>
        < Buttons
          applyFilter={applyFilter}
          labelFilter={labelFilter}
          onReset={true}
          resetFilter={resetFilter}
        />
      </Flex>
    </FormControl>
  )
}

export default DefaultFilterInput
